import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { NAME } from './consts.consts';

export const fetchAll = createAsyncThunk(
  NAME + '/fetchAll',
  withErrorHandling(async () => {
    const [
      { data: consts },
      { data: productcategories },
      { data: publishers },
      { data: users },
      { data: version },
    ] = await Promise.all([
      adserver({ url: '/consts' }),
      adserver({ url: '/productcategories' }),
      adserver({ url: '/publishers' }),
      adserver({ url: '/consts/users' }),
      adserver({ url: '/version' }),
    ]);

    const categories = productcategories.categories
      .filter(category => category.isLeaf === true)
      .map(category => {
        if (category.parentId) {
          const parent = productcategories.categories.find(
            parent => parent.id === category.parentId,
          );
          return {
            id: category.id,
            name: `${parent.name} > ${category.name}`,
          };
        }
        return {
          id: category.id,
          name: category.name,
        };
      });

    const numberOfAllProducts = productcategories.all;

    return {
      ...consts,
      version,
      productcategories: productcategories.categories,
      publishers,
      categories,
      users,
      numberOfAllProducts,
    };
  }),
);

export const fetchCustomProductGroups = createAsyncThunk(
  NAME + '/fetchCustomProductGroups',
  withErrorHandling(async () => {
    const { data: customProductGroups } = await adserver({
      url: '/customproductgroups',
    });
    return { customProductGroups };
  }),
);
